import Hammer from 'hammerjs';
import { mapMutations } from 'vuex';
import qs from 'qs';
import ajax from '@/api';
import Iconfont from '@/components/iconfont.vue';
import IconfontNew from '@/components/IconfontNew.vue';
import {
    judgeMiniApp,
    setToken,
    PaddingTop,
    ttEnvAndIphone,
    getSStorage,
    setSStorage,
    apiRequest,
    isHighAppVersion,
    isHighOrEqualVersion,
    setLStorage,
} from '@/utils';
import CONFIG from '@/config';
import { push, isApp, isHarmony } from 'atour-jsbridge';
import { USER } from '@/utils/jsBridgeEventName';

const mixin = {
    components: {
        Iconfont,
        IconfontNew,
    },
    data() {
        return {
            platType: getSStorage('platType'),
        };
    },
    computed: {
        ipxPaddingTop() {
            if (PaddingTop()) {
                return `padding-top: ${PaddingTop()};`;
            }
            return '';
        },
        ipxPaddingBottom() {
            if (PaddingTop()) {
                return `padding-bottom: ${PaddingTop()};`;
            }
            return '';
        },
        ttIphonePosition() {
            if (ttEnvAndIphone()) {
                return 'position: initial;';
            }
            return '';
        },
    },
    methods: {
        ...mapMutations(['setRouterStatus']),
        // 刷新
        reload() {
            this.setRouterStatus(false);
            this.$nextTick(() => {
                this.setRouterStatus(true);
            });
        },
        // 登陆方法
        login(params) {
            console.log('============in-login');
            // 判断是否是小程序
            judgeMiniApp().then(({
                body,
                type,
            }) => {
                // 微信小程序
                if (type === 'wechat' || type === 'tt') {
                    // 外部小程序跳转进入页面则使用H5登录
                    if (getSStorage('source') === 'outSideMiniApp') {
                        this.$router.push({
                            name: 'login',
                            query: {
                                redirect_url: encodeURIComponent(window.location.href),
                                name: params,
                            },
                        });
                        return;
                    }
                    body.miniProgram.navigateTo({
                        url: '/pages/Login/Login',
                    });
                } else { // 支付宝小程序
                    // 先尝试跳转新支付宝登录页
                    my.navigateTo({
                        url: '/pages/Login/Login',
                        fail: () => {
                            // 如果跳转失败，则跳转到老的支付宝登录页
                            my?.navigateTo?.({
                                url: '/pages/login/index',
                            });
                        },
                    });
                }
            }).catch(env => {
                // App环境中
                if (env === 'app' || isHarmony) {
                    console.log('app login');
                    push(USER.LOGIN, {}, ({ data }) => {
                        console.log('login==>>', data);
                        const token = data.token;
                        const mebId = data?.mebId;
                        setLStorage('mebId', mebId);
                        setToken(token);
                        const queryObj = this.$route.query || {};
                        const newQuery = { ...queryObj };
                        newQuery.token = token;
                        const [, hashPart = ''] = location.href.split('#');

                        const qstr = qs.stringify(newQuery, {
                            encodeValuesOnly: true,
                        });

                        const url =
                            `${location.origin}${location.pathname}` +
                            (qstr ? `?${qstr}` : '') +
                            (hashPart ? `#${hashPart}` : '');

                        // 一步替换并导航，不新增历史记录
                        location.replace(url);
                        // this.$router.replace({
                        //     name: this.$route.name,
                        //     query: newQuery,
                        // });
                        // this.reload();
                    });
                } else {
                    console.log('您处于H5模式下');
                    this.$router.push({
                        name: 'login',
                        query: {
                            redirect_url: encodeURIComponent(window.location.href),
                            name: params,
                        },
                    });
                }
            });
        },
        // 老apiResFn请求
        apiResFnOld(methods, url, data, options = {}) {
            // 是否展示loading以及弹窗
            const hideLoading = options.hideLoading || false;
            const hideToast = options.hideToast || false;
            let loadingObj;
            let timers;
            // 是否展示loading
            if (!hideLoading) {
                timers = setTimeout(() => {
                    // 接口很快返回，不弹出加载中
                    loadingObj = this.$toast({
                        message: '加载中...',
                        duration: CONFIG.apiTimeout,
                    });
                }, 500);
            }
            console.log('new promise');
            return new Promise((resolve, reject) => {
                console.log('axois');
                ajax(methods, url, data, options)
                    .then(res => {
                        // 正常返回
                        if (+res.retcode === 0) {
                            if (!hideLoading) {
                                if (loadingObj) {
                                    loadingObj.close();
                                } else {
                                    clearTimeout(timers);
                                }
                            }
                            resolve(res);
                        } else {
                            // 异常code
                            switch (+res.retcode) {
                                // 登录状态失效，重新登录
                                case 10002:
                                    if (!hideLoading) {
                                        if (loadingObj) {
                                            loadingObj.close();
                                        } else {
                                            clearTimeout(timers);
                                        }
                                    }
                                    this.login();
                                    break;
                                default:
                                    if (!hideLoading) {
                                        if (loadingObj) {
                                            loadingObj.close();
                                        } else {
                                            clearTimeout(timers);
                                        }
                                    }
                                    if (!hideToast && res.retmsg) {
                                        this.$toast({
                                            message: res.retmsg,
                                            iconClass: 'icon icon-error',
                                            duration: 2000,
                                        });
                                    }
                                    reject(res);
                                    break;
                            }
                        }
                    })
                    .catch(() => {
                        // 接口请求不通时走catch
                        reject('接口请求错误');
                        console.log('ajax error');
                        if (loadingObj) {
                            loadingObj.close();
                        } else {
                            clearTimeout(timers);
                        }
                    });
            });
        },
        // 请求
        apiResFn(methods, url, data, options = {}) {
            return new Promise(async(resolve, reject) => {
                try {
                    const res = await apiRequest(methods, url, data, options);
                    resolve(res);
                    console.log('apiResFn res =', res);
                } catch (errRes) {
                    if (errRes && errRes.retcode) {
                        reject(errRes);
                        // 强制跳转登录页
                        if (+errRes.retcode === 10002) {
                            this.login();
                        }
                    } else {
                        reject(errRes);
                    }
                    console.log('apiResFn errRes =', errRes);
                }
            });
        },
        getGrayInfo() {
            this.apiResFn('post', CONFIG.server + '/miniapp/cash/cashGray', {
                model: {},
            }).then(({ result }) => {
                console.log('getGrayInfo result ====', result, isApp(), isHighAppVersion('3.31.0'), getSStorage('platType'));
                const platType = getSStorage('platType');
                if (result) {
                    if (isApp()) {
                        setSStorage('grayPay', isHighAppVersion('3.31.0') ? result : false);
                        setSStorage('isSetGrayPay', !!isHighAppVersion('3.31.0'));
                    } else if (platType === 6) {
                        setSStorage('grayPay', isHighOrEqualVersion('3.31.0') ? result : false);
                        setSStorage('isSetGrayPay', !!isHighAppVersion('3.31.0'));
                    } else {
                        setSStorage('grayPay', result);
                        setSStorage('isSetGrayPay', false);
                    }
                } else {
                    setSStorage('grayPay', false);
                    setSStorage('isSetGrayPay', false);
                    judgeMiniApp().then(({ type, body }) => {
                        if (type === 'wechat') {
                            body.miniProgram.postMessage({
                                data: {
                                    type: 'paymentReduce',
                                    alphaLevel: false,
                                },
                            });
                        }
                    }).catch(env => {
                        if (env === 'app') {
                            push(USER.UPDATE_ALPHA, {
                                alphaLevel: false,
                            });
                        }
                    });
                }
            }).catch((res) => {
                console.log('getGrayInfo errRes ====', res);
                setSStorage('grayPay', false);
                setSStorage('isSetGrayPay', false);
            });
        },
    },
    directives: {
        // 点击
        tap: {
            bind(el, binding) {
                const { value } = binding;
                const hammer = new Hammer(el);
                hammer.on('tap', e => {
                    value(e);
                });
            },
        },
        // 长按
        press: {
            bind(el, binding) {
                const { value } = binding;
                const hammer = new Hammer(el);
                hammer.on('press', e => {
                    value(e);
                });
            },
        },
        // 滑动
        swipe: {
            bind(el, binding) {
                const { value } = binding;
                const hammer = new Hammer(el);
                hammer.on('swipe', e => {
                    value(e);
                });
            },
        },
    },
};
export default mixin;
